import { APIMenuDefinition, APIMenuItem, SRAMenuResponse } from '../types';

export function SRAMenuTransformer(resp: SRAMenuResponse[]): APIMenuDefinition {
  return {
    features: [
      {
        items: resp.map((sra) => {
          const item: APIMenuItem = {
            id: sra.id,
            link: sra.items[0].path,
            name: sra.title,
            openExternal: sra.items[0].id === 'login.appliance.index',
          };
          if (sra.featureFlag) {
            item.featureFlag = sra.featureFlag;
          }
          return item;
        }),
      },
    ],
  };
}
